
import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { DocumentationConfigurationService, Section } from '@icadsistemi/ngx-icadsistemi-documentation-inline';
import { Subscription } from 'rxjs/Subscription';
import { CognitoService } from 'src/app/services/cognito/cognito.service';
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
  selector: 'app-external-layout',
  templateUrl: './external-layout.component.html',
})
export class ExternalLayoutComponent implements OnInit {
  private toggleButton: any;
  private sidebarVisible: boolean;
  mobile_menu_visible: any = 0;
  private _router: Subscription;

  constructor(private router: Router, private element: ElementRef,public configurations: ConfigurationService,public docConfig: DocumentationConfigurationService,private cognitoService: CognitoService) {
    this.sidebarVisible = false;
    docConfig.initEnvironment(ConfigurationService.documentationBaseApiGwUrl, cognitoService.idToken);
  }
  ngOnInit() {
  }

  /**
   * Handle documentation loaded
   * @param e event info
   */
  public onDocumentation_Loaded(e: any) {
    let doc = e as Section;
    // console.log(e);
    if (doc) {
      this.configurations.documentationInput.currentSection = doc;
    }
  }
}

